<template>
  <div class="container justify-center">
    <v-container grid-list-xs>
      <v-card width="500" class="mx-auto">
        <v-card-title primary-title> Deposit Cash </v-card-title>
        <v-card-text class="px-10">
          <v-form ref="MoneyDep">
            <BaseDate
              outlined
              label="Deposit Date"
              v-model="cashDep.date"
            ></BaseDate>
            <v-select
              outlined
              solo
              append-icon="fas fa-search-dollar"
              v-model.trim="cashDep.amountType"
              :items="GetCashTypes"
              :rules="[v => !!v || 'Cash Type is required']"
              label="Money Type"
              required
              no-data-text="Refresh the page"
            ></v-select>
            <BaseNumInput
              :rules="[paymentRule]"
              append-icon="fas fa-hand-holding-usd"
              outlined
              solo
              v-model.trim="cashDep.Amount"
              label="Deposit Amount"
            ></BaseNumInput>

            <v-text-field
              outlined
              solo
              append-icon="fas fa-comment"
              :rules="[v => !!v || 'Details is require']"
              name="DetailsDepositMoney"
              label="Info"
              id="DetailsDepositMoneyID"
              v-model="cashDep.Details"
            ></v-text-field>
          </v-form>
          <!-- <small class="text-center warning white--text d-block"
            >Note the Capital amount is based on
            <strong class="black--text">{{ UsersToken.CashBase }}</strong>
          </small> -->
        </v-card-text>
        <v-card-actions class="px-10">
          <v-btn :loading="clicked" @click="OnDepMoney" color="success" block
            >Save Money</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      clicked: false,
      cashDep: {
        amountType: "",
        Details: "",
        Amount: null,
        date: "",
        time: "",
      },
    };
  },
  computed: {
    ...mapGetters(["UsersToken", "GetCashTypes"]),
  },
  methods: {
    OnDepMoney() {
      if (this.$refs.MoneyDep.validate()) {
        this.clicked = true;
        // this.cashDep.date = this.Current().date;
        this.cashDep.time = this.Current().time;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/Reports/cash/DhigidHanti",
            data: { Dhigid: this.cashDep },
          })
          .then(() => {
            this.cashDep.amountType = "";
            this.cashDep.Details = "";
            this.cashDep.Amount = 0;
            this.cashDep.date = "";

            this.$refs.MoneyDep.resetValidation();
            this.clicked = false;
          })
          .catch(() => {
            // console.log(error);
            this.clicked = false;
          });
      }
    },
    paymentRule(v) {
      //   v = v.replace(/,/g, "");
      let andCon = v && v.replace(/,/g, "") > 0;
      return andCon || "Invalid Amount";
    },
  },
  created() {
    this.cashDep.date = this.Current().date;
  },
};
</script>
